<template>
	<!--Inicio Slidshow -->
	<div class="SlideShow miVue">

		<div class="slide" v-for="number in [currentNumber]" :key='number'>
			<fade-transition>
				<div class="Fondo" :style="{ backgroundImage: 'url(' + currentSlide.img + ')' }"></div>
			</fade-transition>

			<zoom-center-transition>
				<div class="Content" v-on:mouseover="stopRotation" v-on:mouseout="startRotation">
					<h1 class="textosRojos"> {{currentSlide.h1}} </h1>
					<h2>{{currentSlide.h2}}</h2>
					<br>
						<router-link tag="a" :to="{name: currentSlide.ligaBtn}" class="btnEachService">
							Read More
						</router-link>
						<!--
						<a :href="(url)+currentSlide.ligaBtn" class="btnEachService">
							Read More
						</a>
						-->
				</div>
			</zoom-center-transition>
		</div>

		<div class="Show_Controls">
			<div class="Flechas">
				<div class="BtnLeft" >
					<!--  <span @click="prev" v-if="!isversionMovil " > -->
					<span @click="prev"	>
					</span>
				</div>

				<div class="espacio">
					<div class="Menu_Inferior">
						<ul>
							<li>
								<a @click="crlPuntosInferiores(0)" >
									<span :class="{ active: currentNumber === 0 } " ></span>
								</a>
							</li>
							<li>
								<a @click="crlPuntosInferiores(1)"	>
									<span :class="{ active: currentNumber === 1 } " ></span>
								</a>
							</li>
							<li>
								<a @click="crlPuntosInferiores(2)"	>
									<span :class="{ active: currentNumber === 2 } " ></span>
								</a>
							</li>
							<li>
								<a @click="crlPuntosInferiores(3)"	>
									<span :class="{ active: currentNumber === 3 } " ></span>
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div class="BtnRight">
					<!-- <span @click="next" v-if="!isversionMovil "> -->
					<span @click="next" >
					</span>
				</div>

			</div> <!-- Flechas -->
		</div> <!-- Show Controls -->
	</div>



</template>
 
<script>
import JQuery from 'jquery'
var $ = JQuery
import VLazyImage from "v-lazy-image";

import image1 from "../assets/img/slideShow/virado_header_1.jpg";
// import image2 from "../assets/img/slideShow/virado_header_2.jpg";
import image3 from "../assets/img/slideShow/virado_header_3.jpg";
import image4 from "../assets/img/slideShow/virado_header_4.jpg";
import image5 from "../assets/img/slideShow/virado_header_5.jpg";

import placeHolder_image1 from "../assets/img/slideShow/placeholder_header_1.jpg";
// import placeHolder_image2 from "../assets/img/slideShow/placeholder_header_2.jpg";
import placeHolder_image3 from "../assets/img/slideShow/placeholder_header_3.jpg";
import placeHolder_image4 from "../assets/img/slideShow/placeholder_header_4.jpg";
import placeHolder_image5 from "../assets/img/slideShow/placeholder_header_5.jpg";

export default {
	name: "SlideShow",
	components: { VLazyImage },

	data: function() {
		return {
			slides: [
				{
					img: image1,
					placehold: placeHolder_image1,
					h1:
					"Are you concerned about the security of your personnel traveling to or working in Mexico?",
					h2: "We offer executive transportation and protection",
					ligaBtn: "execProtection"
				},
				{
					img: image4,
					placehold: placeHolder_image4,
					h1: "Do you need to transport groups and equipment in Mexico safely and without trouble?",
					h2: "We offer logistics in security for events and productions",
					ligaBtn: "secLogistics"
				},
				{
					img: image5,
					placehold: placeHolder_image5,
					h1: "Do you want to know with whom you are dealing in Mexico?",
					h2: "We can help with background checks and asset searches",
					ligaBtn: "intel"
				},
				{
					img: image3,
					placehold: placeHolder_image3,
					h1: "Do you know how to react when facing a personal threat in Mexico?",
					h2: "We offer training and talks on security",
					ligaBtn: "talks"
				}
				/*
				{
					img: image2,
					placehold: placeHolder_image2,
					h1: "Is your guard staff system efficient?",
					h2: "we provide services for monitoring guards",
					ligaBtn: "guard"
				}
				*/
			],
			currentNumber: 0,
			size: "_movil_",
			url: "",
			isversionMovil: false,
			timer: null
		};
	}, // end data

	mounted: function() {
		this.startRotation();
		//aplicar el mismo alto del canvas al span del fondo
		// let alto = $(window).height();
		// let ancho = $(window).width();

		this.getUrlOwnServer();

		//this.cacharSize();
		this.$nextTick(function() {
			window.addEventListener("resize", this.getWindowWidth);

			//Init
			this.getWindowWidth();
		});
	},

	methods: {
		startRotation: function() {
			this.timer = setInterval(this.next, 7000);
		},

		stopRotation: function() {
			clearTimeout(this.timer);
			this.timer = null;
		},

		next: function() {
			this.currentNumber += 1;
			//console.log(" el valor de currentNumber " + this.currentNumber);
			if (this.currentNumber > 3) {
				this.currentNumber = 0;
				//console.log(" el valor de currentNumber " + this.currentNumber);
			}
		},

		prev: function() {
			this.currentNumber -= 1;
			if (this.currentNumber < 0) {
				this.currentNumber = 3;
				//console.log(" el valor de currentNumber " + this.currentNumber);
			}
		},

		beforeEnter: function() {
			this.pre = true;
			//console.log("Pre entra transicion")
		},

		enter() {
			this.pre = false;
			this.current = true;
		},

		leave() {
			//el.style.opacity = 0
			this.current = false;
			this.post = true;
		},

		getUrlOwnServer() {
			let host = $(location).attr("href");
			let urlMostrada = host.toString();
			this.url = urlMostrada;
		},

		getWindowWidth() {
			if (window.innerWidth < 520) {
				this.isversionMovil = true;
			} else {
				this.isversionMovil = false;
			}
			//console.log("is movil " + this.isversionMovil)
		},

		crlPuntosInferiores(cual) {
			//console.log("se hace click en puntos inferiores");
			return (this.currentNumber = cual);
		}
	}, // end methods

	beforeDestroy() {
		window.removeEventListener("resize", this.getWindowWidth);
	},

	computed: {
		currentSlide: function() {
			return this.slides[Math.abs(this.currentNumber) % this.slides.length];
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" >
@import url("../assets/less/soloVariables.less");

.Fuente_h1_SlideShow () {
	font-family: @fuente_principal;
	font-size: 2.8em;
	font-weight: 600;
}

.Fuente_h2_SlideShow () {
	font-family: @fuente_principal;
	font-size: 1.3em;
	font-weight: 400;
	letter-spacing: 1.4px;
}

.BtnSlideShow() {
	font-family: @fuente_principal;
	text-transform: uppercase;
	font-size: 0.7em;
	letter-spacing: 2px;
	color: white;

	width: 150px;
	padding: 20px;
	border: 0px;
	//margin-top: 10px;
}

.ctr_slideShow(@backGround) {
	justify-content: center;
	flex: 1 1 auto;
	align-self: center;
	padding: 30px;
	margin: 30px;
	background-image: @backGround;
	background-size: cover;
	transition: background-image 250ms ease-in-out;
}

.PreShow {
	opacity: 0;
}

.Show {
	opacity: 0.5;
}

.PostShow {
	opacity: 0;
}

.SlideShow {
	//border: 1px solid red;

	justify-content: center;
	align-self: center;
	//width: 100%;

	.slide {
		//display: flex;
		//justify-content: center;
		//flex: 1 1 auto;
		align-self: center;
		top: 0px;

		flex-direction: column;

		.Fondo {
			display: block;

			height: 100vh;

			background-size: cover;
			background-position: center center;
			background-repeat: no-repeat;
			//border: 5px solid gray;
			@media @tablet {
			}
		}

		.Content {
			//position: absolute;
			//top: 25%;
			//border: 1px solid green;
			margin: auto;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;

			z-index: 1;
			font-size: 80%;
			height: 300px;
			//border: 2px solid red;

			text-align: center;
			align-self: center;
			align-content: center;
			justify-content: center;

			width: 70%;

			@media @tablet {
				top: 5%;
				//font-size: 70%;
				width: 70%;
			}

			@media @mobile {
				top: 0%;
				font-size: 60%;
				width: 90%;
				padding: 0px 20px;
			}

			.btnEachService {
				align-self: center;
				padding-left: 20px;
				text-align: center;
				.BtnSlideShow();
				background-color: @color_Principal_Logo;
				&:hover {
					background-color: lighten(@color_Principal_Logo, 5);
				}
				@media @tablet {
					font-size: 0.8em;
					margin-top: 20px;
					//padding-bottom: 8%;
				}
			}

			img {
				top: 0%;
			}

			h1 {
				//top: 20%;
				.Fuente_h1_SlideShow();
				margin-top: 0px;
				//width: 70%;
				font-size: 4.3em;
				align-self: center;
				//padding: 20px 20px;
				@media @tablet {
					font-size: 3.1em;
					margin-top: 10%;
				}
				@media @mobile {
					margin-top: 5%;
					font-size: 3.1em;
				}
			}

			h2 {
				.Fuente_h2_SlideShow();
				align-self: center;
				@media @tablet {
					font-size: 1.9em;
					margin-top: 10px;
				}
				@media @mobile {
					font-size: 2.2em;
					margin-top: 10px;
					margin-bottom: 20px;
				}
			}

			.btnEachService {
				@media @mobile {
					font-size: 1.1em;
				}
			}
		} // Content
	} // slide
} // end SlideShow

.Menu_Inferior {
	//background-color: red;
	//position: absolute;
	margin-top: 5%;
	padding-right: 50px;
	//width: 100%;
	text-align: center;
	//z-index: 50;
	@media @tablet {
		//bottom: 2px;
	}
	@media @mobile {
	}

	ul {
		list-style: none;
		padding-right: 30px;
		li {
			display: inline-block;

			a {
				span {
					display: block;
					width: 15px;
					height: 15px;
					margin-right: 10px;
					background-image: url("../assets/img/controls/control_still.png");
					background-size: cover;
					background-position: center;
					background-repeat: no-repeat;

					transition: background-image 250ms ease-in-out;
					transition: background-size 250ms ease-in-out;
					cursor: pointer;
				}
				.active {
					background-image: url("../assets/img/controls/control_current.png");
					background-size: 15px 15px;
					background-position: center;
					background-repeat: no-repeat;
				}
			}
			a:hover {
				span {
					//padding: 20px 20px;
					background-image: url("../assets/img/controls/control_over.png");
					background-size: 15px 15px;
					background-position: center;
					background-repeat: no-repeat;

					//transition: background-image 250ms ease-in-out;
				}
			}
		} // end li
	} // end ul
}

.Show_Controls {
	//display: flex;
	//justify-content: center;

	//border: 1px solid pink;

	.Flechas {
		display: flex;
		flex-flow: row;
		position: absolute;
		top: 250px;
		width: 100%;
		height: 400px;
		justify-content: center;

		//border: 2px  solid white;
		@media @tablet {
			top: 250px;
		}

		@media @mobile {
			top: 450px;
			width: 90%;
		}
		.BtnLeft {
			span {
				display: block;
				width: 80px;
				height: 80px;
				background-image: url(../assets/img/controls/A_fondo_flechas_Izq.png);
				background-size: cover;
				background-position: center center;
				background-repeat: no-repeat;
				cursor: pointer;
				transition: background-image 0.4s ease-in-out;
				&:hover {
					background-image: url(../assets/img/controls/B_fondo_flechas_Izq.png);
				}
			}

			img {
				width: 80px;
			}
		}

		.espacio {
			flex: 3 1 auto;
			width: 20%;
			display: flex;
			justify-content: center;
			align-items: flex-end;

			@media @mobile {
				width: 25%;
				height: 30%;
			}

			.Menu_Inferior {
				// display: absolute;
				top: 0px;
			}
		}

		.BtnRight {
			span {
				//background-color: red;
				position: absolute;
				right: 0px;

				width: 80px;
				height: 80px;
				background-image: url(../assets/img/controls/A_fondo_flechas_Der.png);
				background-size: cover;
				background-position: center center;
				background-repeat: no-repeat;
				cursor: pointer;
				transition: background-image 0.4s ease-in-out;
				&:hover {
					background-image: url(../assets/img/controls/B_fondo_flechas_Der.png);
				}

				img {
					width: 80px;
				}
				@media @mobile {
					right: -20px;
				}
			}
		}
	} // end Flechas
} // end Show_Controls
</style>
